import { Action, createReducer, on } from '@ngrx/store';
import { Person } from '../../../core/model/central/person.model';
import { Message } from '../../../message-list/message.model';
import { PatientsActions } from './patients.actions';

export const STORE_FEATURE_KEY_PATIENTS = 'patients';

export interface PatientsState {
    selectedPatient: Person;
    searchPatients: Array<Person>;
    patientSearchLoading: boolean;
    patientDetailsLoading: boolean;
    patientMessages: Array<Message>;
    messagesLoading: boolean;
    strategySaving: boolean;
    selectedDestinator: any;
    isSubscriptionUpdated: boolean;
}

export const initializePatientState: PatientsState = {
    selectedPatient: undefined,
    searchPatients: [],
    patientSearchLoading: false,
    patientDetailsLoading: false,
    patientMessages: [],
    messagesLoading: false,
    strategySaving: false,
    selectedDestinator: undefined,
    isSubscriptionUpdated: false
};

const reducer = createReducer(
    initializePatientState,

    on(PatientsActions.searchPatient, (state, payload) =>
        ({
            ...state,
            patientSearchLoading: true
            /*selectedPatient: undefined*/
        })),
    on(PatientsActions.searchPatientSuccess, (state, {patients}) =>
        ({
            ...state,
            patientSearchLoading: false,
            searchPatients: patients
        })),

    on(PatientsActions.getSelectedPatient, (state, payload) =>
        ({
            ...state,
            patientDetailsLoading: true,
            selectedPatient: undefined
        })),
    on(PatientsActions.getSelectedPatientSuccess, (state, {selectedPatient}) =>
        ({
            ...state,
            patientDetailsLoading: false,
            selectedPatient: {
                ...selectedPatient,
                patientName: `${selectedPatient.firstName} ${selectedPatient.middleName} ${selectedPatient.lastName}`
            }
        })),

    on(PatientsActions.getPatientByRemoteId, (state, payload) =>
        ({
            ...state,
            patientDetailsLoading: true
        })),
    on(PatientsActions.getPatientByRemoteIdSuccess, (state, {selectedPatient}) =>
        ({
            ...state,
            patientDetailsLoading: false,
            selectedPatient
        })),
    on(PatientsActions.setPatientStrategy, (state, payload) =>
        ({
            ...state,
            strategySaving: true
        })),

    on(PatientsActions.refresh, (state, payload) =>
        ({
            ...state,
            selectedPatient: undefined // WHY?
        })),

    on(PatientsActions.selectDestinator, (state, {destinator}) =>
        ({ ...state,
           selectedDestinator: destinator
        })),
    on(PatientsActions.openSubscriptionsDialogFromLogs, (state, payload) =>
        ({
            ...state,
            isSubscriptionUpdated: false
        })),
    on(PatientsActions.openSubscriptionsDialogFromAngularJSSuccess, (state, {isSubscriptionUpdated}) =>
        ({
            ...state,
            isSubscriptionUpdated
        }))
);

// tslint:disable-next-line:typedef only-arrow-functions
export function PatientsReducer(state: PatientsState | undefined, action: Action) {
    return reducer(state, action);
}
